export enum MyFinanceTabs {
  Stocks = "stocks",
  Cards = "cards",
  Accounts = "accounts",
  Deposits = "deposits",
  Loans = "loans",
  Bonds = "bonds",
}

export enum BankingTab {
  Transactions = "transactions",
  Templates = "templates",
}
